// extracted by mini-css-extract-plugin
export default {"component":"region-select-component_component_F4LRk"};